var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"register-modal modal-box"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',[_vm._v("X")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.currentStep === 0)?_c('register-form',{on:{"next":_vm.nextStep}}):_vm._e(),_vm._v(" "),(_vm.currentStep === 1)?_c('register-tips',{on:{"login":_vm.login}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-533801bc","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterModal/RegisterModal.vue
// module id = 1411
// module chunks = 1